import environment from "../configuration/environment";

let numberFormatter: Intl.NumberFormat;
let groupSeparator: string;
let decimalSeparator: string;

function createFormatter() {
    const culture = environment.getCulture();
    const options: Intl.NumberFormatOptions = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };

    numberFormatter = new Intl.NumberFormat(culture, options);

    // Get locale-specific separators
    const parts = numberFormatter.formatToParts(1234.5);
    for (const part of parts) {
        if (part.type === "decimal") {
            decimalSeparator = part.value;
        } else if (part.type === "group") {
            groupSeparator = part.value;
        }
    }
}

function ensureInitialized() {
    if (!numberFormatter) {
        createFormatter();
    }
}

function getFormatter() {
    ensureInitialized();
    return numberFormatter;
}

export function reset() {
    numberFormatter = undefined;
    groupSeparator = undefined;
    decimalSeparator = undefined;
}

export function numberToMoney(amount: number): string {
    if (amount === undefined || amount === null || isNaN(amount)) {
        return "";
    }
    return getFormatter().format(amount);
}

export function moneyToNumber(money: string): number {
    if (money === null) {
        return null;
    }
    if (money === undefined || money === "") {
        return undefined;
    }

    ensureInitialized();

    const cleaned = money
        .replace(new RegExp(`${escapeRegExp(groupSeparator)}`, "g"), "") // Remove all group separators
        .replace(/\s/g, "") // Remove spaces
        .replace(decimalSeparator, "."); // Replace decimal separator with standard '.'

    const parsedMoney = Number(parseFloat(cleaned).toFixed(2));
    return isNaN(parsedMoney) ? undefined : parsedMoney;
}

// Helper function to properly escape RegExp special characters
function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}
